package hk.com.vr360_demo2.webapp.ui

import mui.material.PaletteMode
import mui.material.styles.Theme
import mui.material.styles.ThemeOptions
import mui.material.styles.createTheme
import kotlin.js.json
import kotlin.js.unsafeCast

/** Global UI font stack for MUI typography and CssBaseline (body). */
const val APP_FONT_FAMILY_CSS: String =
    "'Noto Sans TC','Noto Sans SC','Microsoft JhengHei','PingFang TC',Montserrat,Arial,sans-serif"

private fun themeOptions(mode: PaletteMode, backgroundDefault: String) = json(
    "palette" to json(
        "mode" to mode,
        "primary" to json("main" to "#f26522"),
        "secondary" to json("main" to "#9c27b0"),
        "background" to json("default" to backgroundDefault),
    ),
    "shape" to json(
        "borderRadius" to 10,
    ),
    "typography" to json(
        "fontFamily" to APP_FONT_FAMILY_CSS,
    ),
    "components" to json(
        "MuiButton" to json(
            "defaultProps" to json(
                "disableElevation" to true,
            ),
        ),
    ),
).unsafeCast<ThemeOptions>()

val lightTheme: Theme = createTheme(themeOptions(PaletteMode.light, "#f7f8fa"))
val darkTheme: Theme = createTheme(themeOptions(PaletteMode.dark, "#121212"))
